import { Box, Typography } from "@mui/material";
import { VolumeTypeEnum } from "../../../../../store/types/secureVolume.types";
import { fmt } from "../types";
import { SecuredIndicator } from "./SecuredIndicator";
import { VolumeTypeSummary } from "./VolumeTypeSummary";

interface TotalDisplayProps {
  total?: number;
  securedPct?: number | null;
  typeMap?: Map<VolumeTypeEnum, number>;
}

export function TotalDisplay({ total, securedPct, typeMap }: TotalDisplayProps) {
  if (typeMap) {
    return <VolumeTypeSummary typeMap={typeMap} securedPct={securedPct} />;
  }

  return (
    <Box sx={{ textAlign: "right" }}>
      <Typography variant="body2" fontWeight={600}>
        {fmt.format(total ?? 0)} kWh
      </Typography>
      {securedPct !== undefined && securedPct !== null && (
        <SecuredIndicator percentage={securedPct} />
      )}
    </Box>
  );
}
